// Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../state/explorer/actions';
import { getKeywords } from '../state/domains/keywords/actions';
import { getShapes } from '../state/domains/shapes/actions';
import { getGeom } from '../state/documents/local/actions';
import { groupShapes } from '../state/domains/shapes/reducer';
import { getDocumentDetails, getDocumentFiles, downloadFile } from '../state/documents/actions';
import { filterShapes, keywordsById } from '../state/documents/reducer';
import { groupTitles, groupDocuments } from '../state/explorer/reducer';

// Components
import Explorer from '../components/Explorer/Explorer';

// DnD
import { flow } from 'lodash';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';

function mapStateToProps(state) {

	return {
		explorer: state.explorer,
		groupedShapes: groupShapes(state.domains.shapes.list),
		domains: state.domains,
		selectedKeywords: keywordsById(state.explorer.filter),
		selectedShapes: filterShapes(state.explorer.filter),
		groupedTitles: groupTitles(state.explorer.documents),
		groupedDocuments: groupDocuments(state.explorer.documents),
		userProjectAccess: state.login.projectaccess,
		projects: state.login.choosenbyuser,
		hideDocumentsFromMap: state.explorer.hideDocumentsFromMap,
		isGisOnly: state.login.isGisOnly,
		isGisAdmin: state.login.isGisAdmin
	};
}

function mapDispatchToProps(dispatch) {
	return { 
		actions: bindActionCreators(actions, dispatch),
		getDocumentFiles: bindActionCreators(getDocumentFiles, dispatch),
		getDocumentDetails: bindActionCreators(getDocumentDetails, dispatch),
		getGeom: bindActionCreators(getGeom, dispatch),
		downloadFile: bindActionCreators(downloadFile, dispatch),
		getShapes: bindActionCreators(getShapes, dispatch),
		getKeywords: bindActionCreators(getKeywords, dispatch)
	};
}

export default flow(DragDropContext(HTML5Backend), connect(mapStateToProps, mapDispatchToProps))(Explorer);



// WEBPACK FOOTER //
// ./src/containers/ExplorerContainer.js